const userData = (value) => {
  return value ? value : 'No info';
};

export default userData;